module.exports = __webpack_public_path__ + "static/media/tyler_choi.f7a26628.png";